import { Model, Attr } from 'spraypaint';
import ApplicationRecord from '../ApplicationRecord';

@Model()
export default class RecruitmentType extends ApplicationRecord {
  static jsonapiType = 'recruitment-types';

  static listHeaders() {
    return [
      {
        text: 'ID',
        value: 'id',
        width: 100,
      },
      {
        text: 'Name',
        value: 'name',
      },
      {
        text: 'Code',
        value: 'code',
      },
      {
        text: 'Created',
        value: 'createdAt',
      },
    ];
  }

  static scopeFactory() {
    return RecruitmentType.includes([]);
  }

  @Attr() createdAt: string;

  @Attr() name: string;

  @Attr() description: string;

  @Attr() code: string;
}
